import { BusinessProcess } from '@ebalance/proto/bfftypes/v1/approval_flow_type_pb'
import type { ApprovalTask } from '@ebalance/proto/bffuser/v1/approval_task_model_pb'
import { BiddingApprovalState } from '@ebalance/proto/bffuser/v1/bidding_common_model_pb'

/**
 * 承認案件一覧のフィルタ状態。
 *
 * Phase 1 簡略: 「権限」フィルタ (自分が承認者/申請者) は未実装。
 * BFF が全件返し、frontend 側でステータス / 業務プロセスのみ絞り込む。
 * 「権限」フィルタは Phase 2 で UserDirectory と連携して実装予定。
 */
export type ApprovalTaskFilter = {
  /** undefined = すべて、それ以外は選択されたステータス */
  approvalState: BiddingApprovalState | undefined
  /** undefined = すべて、それ以外は選択された業務プロセス */
  businessProcess: BusinessProcess | undefined
}

export const DEFAULT_FILTER: ApprovalTaskFilter = {
  // 初期表示は申請中 (spec AC-001 初期値)
  approvalState: BiddingApprovalState.PENDING,
  businessProcess: undefined,
}

/**
 * タスク一覧をフィルタ条件で絞り込む純関数。
 */
export function filterApprovalTasks(
  tasks: ApprovalTask[],
  filter: ApprovalTaskFilter,
): ApprovalTask[] {
  return tasks.filter((task) => {
    if (
      filter.approvalState !== undefined &&
      task.approvalState !== filter.approvalState
    ) {
      return false
    }
    if (
      filter.businessProcess !== undefined &&
      task.businessProcess !== filter.businessProcess
    ) {
      return false
    }
    return true
  })
}
